const PIXEL_ID = '1393203911993246';

let initialized = false;

export function initMetaPixel() {
  if (initialized) return;

  /* eslint-disable */
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */

  window.fbq('init', PIXEL_ID);
  window.fbq('track', 'PageView');
  initialized = true;
}

// Generate a unique event ID for deduplication with Conversions API
export function generateEventId() {
  return `${Date.now()}-${Math.random().toString(36).substring(2, 10)}`;
}

// Track page view (call on route changes)
export function trackPageView() {
  if (window.fbq) {
    window.fbq('track', 'PageView');
  }
}

// Lead form submission (landing pages)
export function trackLead(data = {}) {
  if (window.fbq) {
    window.fbq('track', 'Lead', data);
  }
}

// User completed registration
export function trackCompleteRegistration(data = {}) {
  if (window.fbq) {
    window.fbq('track', 'CompleteRegistration', data);
  }
}

// Viewing a campaign detail page
export function trackViewContent(data = {}) {
  if (window.fbq) {
    window.fbq('track', 'ViewContent', data);
  }
}

// Sending a message / contacting
export function trackContact(data = {}) {
  if (window.fbq) {
    window.fbq('track', 'Contact', data);
  }
}

// Submitting a campaign application
export function trackSubmitApplication(data = {}) {
  if (window.fbq) {
    window.fbq('track', 'SubmitApplication', data);
  }
}
